import { Link } from "react-router-dom";
import { ArrowUpRight, Sparkles } from "lucide-react";

import { Container } from "@/platform/layout/container";
import { Badge } from "@/platform/ui/badge";
import { Button } from "@/platform/ui/button";
import { Blob, SoftStar } from "@/platform/ui/illustrations/blobs";
import { SparkleCluster } from "@/platform/ui/illustrations/spot";

interface ComingSoonProps {
  kicker: string;
  title: string;
  description?: string;
}

export function ComingSoonPage({ kicker, title, description }: ComingSoonProps) {
  return (
    <div className="relative overflow-hidden bg-mesh min-h-[calc(100vh-56px)]">
      <Blob
        color="violet"
        className="pointer-events-none absolute -left-32 -top-20 w-96 opacity-30 blur-2xl animate-blob"
      />
      <Blob
        color="pink"
        className="pointer-events-none absolute -right-32 bottom-0 w-96 opacity-25 blur-2xl animate-blob"
      />
      <SoftStar
        color="yellow"
        className="pointer-events-none absolute right-12 top-24 w-14 opacity-60 animate-float"
      />

      <Container size="default" className="relative py-20 md:py-32">
        <div className="mx-auto max-w-2xl text-center animate-fade-up">
          <div className="mx-auto inline-block">
            <SparkleCluster className="size-24 animate-float" />
          </div>
          <Badge variant="accentSolid" className="mx-auto mt-2 w-fit">
            <Sparkles className="size-3" aria-hidden />
            {kicker}
          </Badge>
          <h1 className="mt-6 font-display text-[length:var(--text-display-lg)] font-semibold leading-[var(--text-display-lg--line-height)] tracking-[var(--text-display-lg--letter-spacing)] text-balance">
            {title}
          </h1>
          {description ? (
            <p className="mt-5 text-[length:var(--text-body-lg)] text-[color:var(--color-muted-foreground)] leading-[var(--text-body-lg--line-height)] text-pretty">
              {description}
            </p>
          ) : null}

          <div className="mt-6 inline-flex items-center gap-2 rounded-full border border-[--color-border] bg-[color:var(--color-card)] px-4 py-2 text-[length:var(--text-caption)] text-[color:var(--color-muted-foreground)] shadow-[var(--shadow-xs)]">
            <span aria-hidden className="size-1.5 rounded-full bg-[color:var(--color-accent)] animate-pulse" />
            Em construção · parte do roadmap público
          </div>

          <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Button asChild size="lg" variant="gradient">
              <Link to="/cadastro">
                Começar pelo diagnóstico
                <ArrowUpRight className="size-4" aria-hidden />
              </Link>
            </Button>
            <Button asChild size="lg" variant="outline">
              <Link to="/metodo">Ver o método</Link>
            </Button>
          </div>
        </div>
      </Container>
    </div>
  );
}
